export default __webpack_public_path__ + "static/group-61-9b883649e080816d6ed2679290d1d6a5.png";